module.exports = new __parcel__URL__("stained-glass-4.f6308819.webp").toString();